import React from "react";
import LegalPage from "../../components/LegalPage";

// Terms of Service - PDF provided by Zelaflo Labs.
const PDF = "https://customer-assets.emergentagent.com/job_workflow-builder-125/artifacts/k7eupj8p_Zelaflo_Labs_Terms_of_Service.pdf";

export default function TermsOfService() {
  return (
    <LegalPage
      title="Terms of Service"
      pdfUrl={PDF}
      description="Our service agreement governing all client engagements with Zelaflo Labs."
      testId="legal-terms"
    />
  );
}
